export default "__VITE_ASSET__ccb89e18__"